import React from 'react';
import { Skeleton } from '@/shared/components/loading/Skeleton';

/**
 * Admin Layout Skeleton
 * Shown while admin routes are initializing
 */
const AdminLayoutSkeleton: React.FC = () => {
  return (
    <div className="flex h-screen bg-neutral-50">
      {/* Sidebar Skeleton */}
      <div className="w-64 bg-white border-r border-neutral-200/50 p-4">
        {/* Logo */}
        <div className="mb-6">
          <Skeleton className="h-10 w-10 rounded-lg mb-2" />
          <Skeleton className="h-5 w-32" />
        </div>

        {/* Menu Items */}
        <div className="space-y-2">
          {Array.from({ length: 7 }).map((_, i) => (
            <div key={i} className="flex items-center gap-3 px-3 py-2">
              <Skeleton className="rounded" />
              <Skeleton className="h-4 w-24" />
            </div>
          ))}
        </div>
      </div>

      {/* Main Content */}
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Header Skeleton */}
        <header className="h-20 bg-white border-b border-neutral-200/50 flex items-center justify-between px-8">
          <Skeleton className="h-7 w-40" />
          <div className="flex items-center gap-3">
            <Skeleton className="rounded-full" />
            <Skeleton className="h-4 w-32" />
          </div>
        </header>

        {/* Content Skeleton */}
        <div className="flex-1 overflow-auto">
          <div className="p-8">
            <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
              {Array.from({ length: 4 }).map((_, i) => (
                <div key={i} className="bg-white border border-neutral-200 rounded-xl p-5">
                  <div className="flex items-center gap-2 mb-3">
                    <Skeleton className="rounded" />
                    <Skeleton className="h-4 w-24" />
                  </div>
                  <Skeleton className="h-8 w-20" />
                </div>
              ))}
            </div>

            {/* Chart Skeleton */}
            <div className="mt-6 bg-white border border-neutral-200 rounded-xl p-6">
              <div className="flex items-center justify-between mb-6">
                <Skeleton className="h-6 w-48" />
                <Skeleton className="h-6 w-20" />
              </div>
              <div className="space-y-4">
                {Array.from({ length: 6 }).map((_, i) => (
                  <div key={i}>
                    <div className="flex items-center justify-between mb-2">
                      <Skeleton className="h-4 w-20" />
                      <Skeleton className="h-4 w-16" />
                    </div>
                    <Skeleton className="h-8 w-full rounded-lg" />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminLayoutSkeleton;
